import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { Breadcrumbs, Grid, IconButton, Typography } from '@mui/material';

import type { MultiButtonOptionType } from 'app/main/components/buttons/MultiButton';
import { Icon, ImageAvatar, Text } from 'app/main/components';
import { useSettings } from 'app/main/components/hooks';
import { MultiButton } from 'app/main/components/buttons';

import type { DetailsButtonProps } from './DetailsPage';
import DetailsPageHeaderSystemInfo from './components/DetailsPageHeaderSystemInfo';
import DetailsPageDeletedHeaderButtons from './components/DetailsPageDeletedHeaderButtons';

export interface DetailsPageHeaderProps {
	module: string;
	model: any;
	isEdit: boolean;
	isAdd?: boolean;
	showLogs: boolean;
	showAvatar?: boolean;
	buttons: MultiButtonOptionType<DetailsButtonProps>[];
	buttonProps: DetailsButtonProps;
	hasRightSidebar: boolean;
	rightSidebarOpen: boolean;
	toggleRightSidebar: VoidFunction;
	additionalInfo?: React.FC<DetailsPageHeaderAdditionalInfoProps>;
}

export interface DetailsPageHeaderAdditionalInfoProps {
	model: any;
}

export default function DetailsPageHeader(props: DetailsPageHeaderProps) {
	const { settings, t } = useSettings(props.module);

	const { ref, width = 0 } = useResizeDetector({ handleHeight: false });

	// TODO:
	// const moduleUrl = `/${settings.modu_title.replaceAll('_', '')}/${props.model.core_type}`;
	const moduleUrl = `/${settings.modu_title.replaceAll('_', '')}`;

	const buttons = props.model[`${settings.modu_short}_deleted`] ? DetailsPageDeletedHeaderButtons : props.buttons;

	return (
		<Grid container spacing={2} sx={{ containerType: 'inline-size' }}>
			{props.showAvatar && (
				<Grid sx={{ display: { '@': 'none', '@600': 'flex' } }}>
					<ImageAvatar
						dimensions={64}
						module={settings.modu_title}
						uid={props.model[`${settings.modu_short}_uid`]}
						avatar={props.model[`${settings.modu_short}_avatar`]}
						initials={props.model[`${settings.modu_short}_title_initials`]}
					/>
				</Grid>
			)}
			<Grid size="grow">
				<div className="relative">
					<div className="mb-8 pr-40">
						<Typography variant="h6">
							{props.isAdd
								? // TODO: SISTEMARE TRADUZIONE
									`${t('NEW')} ${t(`MODULE_${settings.modu_title}_NAME_SINGULAR`)}`
								: props.model[`${settings.modu_short}_title`]}
						</Typography>
						{props.additionalInfo ? <props.additionalInfo model={props.model} /> : <></>}
						<Breadcrumbs className="pt-8" separator={<Icon icon="chevron-right" size={16} />}>
							<Text color="secondary" to="/">
								<Icon className="align-middle mr-4 inline" icon="home-outline" size={18} />
								{t('BREADCRUMBS_DASHBOARD')}
							</Text>
							<Text color="secondary" to={moduleUrl}>
								<Icon className="align-middle mr-4 inline" icon={settings.modu_icon} size={18} />
								{t(`MODULE_${settings.modu_title}_NAME`)}
							</Text>
							<Typography color="textPrimary">
								{props.isAdd ? t('BREADCRUMBS_ADD') : t('BREADCRUMBS_DETAILS')}
							</Typography>
							{props.isEdit && !props.isAdd && (
								<Typography color="textPrimary">{t('BREADCRUMBS_EDIT')}</Typography>
							)}
						</Breadcrumbs>
					</div>
					{!props.showLogs ? (
						<div className="absolute right-0 top-0">
							{props.hasRightSidebar && (
								<IconButton className="flex" onClick={props.toggleRightSidebar}>
									<Icon icon={props.rightSidebarOpen ? 'forwardburger' : 'menu'} />
								</IconButton>
							)}
							{!props.isAdd && <MultiButton buttonProps={props.buttonProps} items={buttons} />}
						</div>
					) : (
						<></>
					)}
					{!props.isAdd && <DetailsPageHeaderSystemInfo module={settings.modu_title} model={props.model} />}
				</div>
			</Grid>
		</Grid>
	);
}
